__turbopack_context__.v({
  "form": "ZFW3Za_form",
  "headline": "ZFW3Za_headline",
  "mobile-headline": "ZFW3Za_mobile-headline",
  "placeholder": "ZFW3Za_placeholder",
  "unit": "ZFW3Za_unit",
});
